import { create } from "zustand";
import { InterfaceChaseItem } from "../types/chase-item-types";
import { DriverInterface } from "../types/driver-type";

export interface DriverResponseInterface extends DriverInterface {
  chaseItem: InterfaceChaseItem[];
}

const defaultValues = {
  isOpen: false,
};

interface IuseRangePicker {
  onToggleRangePicker: () => void;
  onCloseRangePicker: () => void;
  initialValues: typeof defaultValues;
}

export const useRangePicker = create<IuseRangePicker>((set) => ({
  initialValues: defaultValues,
  onToggleRangePicker: () =>
    set((prevState) => ({
      initialValues: {
        ...prevState.initialValues,
        isOpen: !prevState.initialValues.isOpen,
      },
    })),
  onCloseRangePicker: () =>
    set((prevState) => ({
      initialValues: {
        ...prevState.initialValues,
        isOpen: false,
      },
    })),
}));
